export default __webpack_public_path__ + "static/local-poster-cb36083168d5b095ec128662c006c97c.jpg";